module.exports = __webpack_public_path__ + "static/media/YM59_1.24c818c9.jpg";